import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useStyles } from './CommunityParticipantsCount.styles';

interface ICommunityParticipantsCountProps {
  count: number;
  /** Tighter spacing when shown under the title in community lists. */
  variant?: 'profile' | 'list';
}

/**
 * One line: bold count + “community subscribers” label — same pattern as the community profile header.
 */
export default function CommunityParticipantsCount(
  props: ICommunityParticipantsCountProps,
) {
  const { count, variant = 'profile' } = props;
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const statsClass = variant === 'list' ? classes.statsList : classes.stats;

  return (
    <Box className={statsClass}>
      <Typography variant="text-md" component="span">
        <Typography component="span" className={classes.statsValue}>
          {count}
        </Typography>{' '}
        {t('communities.communitySubscribers')}
      </Typography>
    </Box>
  );
}
